export default __webpack_public_path__ + "static/media/pic3.6a84262b.png";